import { component } from 'flightjs';

function PasswordValidator() {
    this.defaultAttrs({
        passwordInput: '#newPassword',
        passwordConfirmInput: '#newPasswordRepeated',
        errorMessageCopy: '#errorMessageCopy',
        errorMessageNode: '#errorMessage'
    });

    this._validatePasswordLength = function () {
        if (this.passwordInput.val().length > 7) {
            return true;
        } else {
            return false;
        }
    };

    this._validatePasswordEquality = function () {
        if (this.passwordInput.val() === this.passwordConfirmInput.val()) {
            return true;
        } else {
            return false;
        }
    };

    this._validatePasswordMainField = function () {
        if (this._validatePasswordLength()) {
            this.passwordInput.removeClass('security-box__form-field--invalid');
            this.errorMessageNode.addClass('hidden');
            return true;
        } else {
            this.passwordInput.addClass('security-box__form-field--invalid');
            this.errorMessageCopy.text(
                'Ditt nya lösenord måste innehålla minst 8 tecken.'
            );
            this.errorMessageNode.removeClass('hidden');
            return false;
        }
    };

    this._validatePassword = function () {
        if (
            this._validatePasswordMainField() &&
            this._validatePasswordEquality()
        ) {
            this.passwordInput.removeClass('security-box__form-field--invalid');
            this.passwordConfirmInput.removeClass(
                'security-box__form-field--invalid'
            );
            this.errorMessageNode.addClass('hidden');
            return true;
        } else {
            this.passwordConfirmInput.addClass(
                'security-box__form-field--invalid'
            );
            this.errorMessageCopy.text(
                'Försök igen och kontrollera att du har skrivit samma lösenord i båda fälten.'
            );
            this.errorMessageNode.removeClass('hidden');
            return false;
        }
    };

    this.after('initialize', function () {
        this.passwordInput = this.select('passwordInput');
        this.passwordConfirmInput = this.select('passwordConfirmInput');
        this.errorMessageCopy = this.select('errorMessageCopy');
        this.errorMessageNode = this.select('errorMessageNode');

        this.on(document, 'change', {
            passwordInput: this._validatePasswordMainField
        });

        this.on(document, 'change', {
            passwordConfirmInput: this._validatePassword
        });
    });
}

export default component(PasswordValidator);
